/**
 * Tema claro/escuro do site público (módulo neutro: usado pelo layout no
 * servidor e pelo ThemeToggle no cliente).
 */
export const THEME_STORAGE_KEY = "ge-theme";
export const THEME_COLOR = { dark: "#050816", light: "#f7f9fc" } as const;

/** Executado inline no <head>: aplica a escolha salva antes do primeiro paint (sem piscar). */
export const THEME_INIT_SCRIPT = `(function(){try{var t=localStorage.getItem("${THEME_STORAGE_KEY}");if(t==="light"||t==="dark"){document.documentElement.setAttribute("data-theme",t);}}catch(e){}})();`;
